const SET_DATA_SCORE = 'SET_DATA_SCORE';
const DATA_SCORE_SESSION_STORAGE_KEY = 'cmLeadScore';

export { SET_DATA_SCORE, DATA_SCORE_SESSION_STORAGE_KEY };
